import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql } from 'react-apollo'
import { companyFragment, viewerFragment, ownerFragment } from 'fragments'
import { imagePath } from 'frontend_core/dist/helpers/image'
import BusinessLayout from 'components/layouts/BusinessLayout/signup'
import { wwwUrl } from 'frontend_core/dist/helpers/url'

function ConsiderationContainer(props) {
  return (
    <BusinessLayout
      title={i18n.t('server.business.considaration.title')}
      description={i18n.t('server.business.considaration.description')}
      {...props}
    >
      <div className="page__even lp-page__padding">
        <div className="page__col1">
          <div className="page-xs12-head">
            <h1 className="page-title">法人アカウント登録 注意事項</h1>
          </div>
          <div className="page-xs12-terms page__static-single">
            <ul className="page__static-single-notype">
              <li>
                ・利用者(管理者・社員)は、本サービス利用開始する前に、別途定める「
                <a href={wwwUrl('/about/terms_of_space_use')}>ゲスト利用規約</a>
                」「
                <a href={wwwUrl('/about/terms')}>スペースマーケット利用規約</a>
                」を承諾のうえ、弊社所定の方法でユーザー登録を行ってください。
              </li>
              <li>
                ・管理者は、管理者用のパスワードについて、第三者に知られないよう管理し、定期的にパスワードを変更するなど、盗用を防止する措置をその責任において行ってください。尚、パスワードの盗用、不正使用その他の事故に関しては弊社は一切責任を負いません。
              </li>
              <li>
                ・利用者(登録社員)が会社利用を選択した予約に際して、誤操作等により生じた損害や予約の変更もしくは取り消しにかかる料金、また利用スペースでの損害が発生した場合の支払い義務を負うものといたします。
              </li>
              <li>
                ・利用者が本サービスを通して予約申込みをした場合は、利用者に対してポイントを付与します。
              </li>
            </ul>
          </div>
        </div>
      </div>
    </BusinessLayout>
  )
}

const withData = graphql(
  gql`
  query BusinessSignupContainer {
    viewer {
      ${viewerFragment}
    }
  }
`,
  {
    options: props => ({
      notifyOnNetworkStatusChange: true,
      variables: {},
    }),
  },
)(ConsiderationContainer)

function mapStateToProps(state) {
  return state
}
export default withRouter(connect(mapStateToProps)(withData))
